import React, { useEffect } from 'react';

import SatModal from '@components/common/satUI/SatModal';
import SatButton from '@components/common/satUI/SatButton';

const SimulationVerifyResultPopup = props => {
  const {
    visible,
    setVisible,
    simulationInfo: {
      hashCheck = '',
      isValid = false,
      underwritingMsgList = [], // 검증오류 메세지 목록
    },
    onOk,
  } = props;
  useEffect(() => {
    if (!isValid && hashCheck !== '') {
      if (!visible) setVisible(true);
    }
  }, [hashCheck]);

  const handleOk = () => {
    setVisible(false);
    onOk();
  };

  const CheckList = ({ msgList0 }) => {
    return (
      <>
        <div className="tit-small">참고사항</div>
        <ul className="dot-type type-m mgt-8">
          {msgList0.map((item, index) => {
            return item.errorMsg && <li key={index}>{item.msg}</li>;
          })}
        </ul>
      </>
    );
  };

  return (
    <SatModal
      visible={visible}
      setVisible={() => setVisible(false)}
      type="info"
      wide
    >
      <>
        <header className="modal-header">
          <h3 className="layer-tit2">시뮬레이션 불가 안내</h3>
        </header>
        <div className="cont">
          <div className="modal-scroll-wrap" id="verifyResult">
            <div className="info-box">
              {/* 참고사항 */}
              {!isValid && <CheckList msgList0={underwritingMsgList} />}
            </div>
          </div>
        </div>
        <div className="layer-footer">
          <SatButton
            styleClass="btn-s blue btn-wide"
            label="확인"
            onClick={handleOk}
          />
        </div>
      </>
    </SatModal>
  );
};

export default React.memo(SimulationVerifyResultPopup);
